import { DgColumn, DgGridContainer, DgGridContent, DgRow, DgText } from "@dasgate/uikit";
import Vue from "vue";
import Component from "vue-class-component";
import { Emit, Prop } from "vue-property-decorator";
import { NewAccreditationCard } from "@/ui/Profile/MyAccreditations/NoAccreditations/_components/NewAccreditationCard";

@Component({ components: { DgColumn, DgRow, DgText, DgGridContainer, DgGridContent, NewAccreditationCard } })
export default class NoAccreditations extends Vue {
  @Prop({ default: () => () => false }) public hideQr!: () => boolean;

  @Emit() onRequestFace() {
    return;
  }

  @Emit() onRequestQr() {
    return;
  }
}
